import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-ncc', templateUrl: './ncc.component.html', styleUrls: ['./ncc.component.scss'] })
export class NccComponent implements OnInit {

  nccImages = [
    '/assets/img/quick-links/ncc/1 (1).jpg',
    '/assets/img/quick-links/ncc/1 (2).jpg',
    '/assets/img/quick-links/ncc/1 (3).jpg',
    '/assets/img/quick-links/ncc/1 (4).jpg',
    '/assets/img/quick-links/ncc/1 (5).jpg',
    '/assets/img/quick-links/ncc/1 (6).jpg',
    '/assets/img/quick-links/ncc/1 (7).jpg',
    '/assets/img/quick-links/ncc/1 (8).jpg',
    '/assets/img/quick-links/ncc/1 (9).jpg',
    '/assets/img/quick-links/ncc/1 (10).jpg',
    '/assets/img/quick-links/ncc/1 (11).jpg',
    '/assets/img/quick-links/ncc/1 (12).jpg',
    '/assets/img/quick-links/ncc/1 (13).jpg',
    '/assets/img/quick-links/ncc/1 (14).jpg',
    '/assets/img/quick-links/ncc/1 (15).jpg',
    '/assets/img/quick-links/ncc/1 (16).jpg',
    '/assets/img/quick-links/ncc/1 (17).jpg',
    '/assets/img/quick-links/ncc/1 (18).jpg',
  ];

  constructor() { }
  ngOnInit(): void { }
}
